import { useScript } from "@bokio/hooks/useScript/useScript";

interface MicrosoftAdsConsentProps {
	onScriptsLoaded: () => void;
}

export const MicrosoftAdsConsent = (props: MicrosoftAdsConsentProps) => {
	useScript("scripts/microsoftAdsConsent.js", props.onScriptsLoaded);

	return null;
};
